export function translateRemoveTitle(tech, args, line, parsed, source, mapping, processed, config) {
  // do(remove_title,T).
  let rules = [];
  let title = source.title?.items?.[mapping[args[0]].title];
  let rule = {
    category: "recommender",
    description: `Remove title ${title.name || ""}`,
    specifier: {
      role: "title"
    },
    action: "remove"
  };
  if (title.name) rule.specifier.id = title.name;
  else if (title.text) {
    rule.specifier.text = {
      startsWith: (title.text.constructor.name === "Array" ? title.text[0].text : title.text)
    };
  }
  else rule.specifier.index = parseInt(mapping[args[0]].title);
  rules.push(rule);
  return rules;
}


export function translateInternalizeTitle(tech, args, line, parsed, source, mapping, processed, config) {
  // do(internalize_title,T).
  let rules = [];
  let title = source.title?.items?.[mapping[args[0]].title];
  if (title) {
    let rule = {
      category: "recommender",
      description: `Internalize title ${title.name || ""} as an annotation`,
      specifier: {
        role: "title"
      },
      action: "replace",
      option: {
        to: {
          role: "annotation",
          external: false,
          x: "50%",
          y: "50%",
          anchor: "center",
          textAlign: "center"
        }
      }
    };
    if (title.name) rule.specifier.id = title.name;
    else if (title.text) {
      rule.specifier.text = {
        startsWith: (title.text.constructor.name === "Array" ? title.text[0].text : title.text)
      };
    }
    else rule.specifier.index = parseInt(mapping[args[0]].title);
    rules.push(rule);
  }
  return rules;
}

export function translateReduceTitleFontSize(tech, args, line, parsed, source, mapping, processed, config) {
  // do(reduce_title_font_size,T)
  let rules = [];
  let title = source.title?.items?.[mapping[args[0]].title];
  let size = Math.round(Math.max(15, Math.min(title.fontSize - 2, title.fontSize * 0.8)));
  if (title) {
    let rule = {
      category: "recommender",
      description: `Reduce font size of title ${title.name || ""}`,
      specifier: {
        role: "title"
      },
      action: "modify",
      option: {
        fontSize: size
      }
    };
    if (title.name) rule.specifier.id = title.name;
    else if (title.text) {
      rule.specifier.text = {
        startsWith: (title.text.constructor.name === "Array" ? title.text[0].text : title.text)
      };
    }
    else rule.specifier.index = parseInt(mapping[args[0]].title);
    rules.push(rule);
  }
  return rules;
}

export function translateIgnoreTitleWidth(tech, args, line, parsed, source, mapping, processed, config) {
  // do(ignore_title_width,T)
  let rules = [];
  let title = source.title?.items?.[mapping[args[0]].title];
  if (title) {
    let rule = {
      category: "recommender",
      description: `Ignore the width of title ${title.name || ""}`,
      specifier: {
        role: "title"
      },
      action: "modify",
      option: {
        width: null
      }
    };
    if (title.name) rule.specifier.id = title.name;
    else if (title.text) {
      rule.specifier.text = {
        startsWith: (title.text.constructor.name === "Array" ? title.text[0].text : title.text)
      };
    }
    else rule.specifier.index = parseInt(mapping[args[0]].title);
    rules.push(rule);
  }
  return rules;
}